import template from './template.html'

angular
  .module('contabilidad.reportesexternos')
  .component('contabilidadReportesexternosSaldosclientesDatos', {
    controller: ContabilidadReportesexternosSaldosclientesDatosComponent,
    template,
    bindings: {
      busqueda: '<',
    },
  })

function ContabilidadReportesexternosSaldosclientesDatosComponent (ReportesexternosSaldosclientesService, $document) {
  var $ctrl = this
  $ctrl.$onInit = $onInit
  $ctrl.copiar = copiar

  function $onInit () {
    $ctrl.copiable = $document[0].queryCommandSupported('copy')
    $ctrl.promise = ReportesexternosSaldosclientesService.get($ctrl.busqueda)
      .then(function (resolve) {
        $ctrl.data = resolve.data
        arreglardatos()
      })
  }

  function arreglardatos () {
    var texto = ''
    var encabezados = Object.keys($ctrl.data[0])
    texto += encabezados.join('\t') + '\n'
    $ctrl.data.forEach(function (item) {
      encabezados.forEach(function (prop) {
        texto += item[prop] + '\t'
      })
      texto += '\n'
    })
    $ctrl.cadena = texto
  }

  function copiar () {
    var elemento = $document[0].getElementById('contabilidad.reportesexternos.saldosclientes.datos')
    elemento.focus()
    elemento.select()
    document.execCommand('copy')
  }

}



// WEBPACK FOOTER //
// ./src/contabilidad/reportesexternos/components/saldosclientes/datos/component.js